import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {Observable, of as observableOf} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {Device} from '../model/iot-device';
import {DeviceService} from '../service/device.service';

@Injectable()
export class IotDevicesResolver {

  constructor(private deviceService: DeviceService,
              private logger: NGXLogger,
              private router: Router) {
    this.logger.debug('constructing devices resolver.');
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<Device[]> {
    this.logger.debug('IotDevicesResolver: Waiting for sensor data to be available.');

    return this.deviceService.getAllDevices().pipe(catchError((error) => {
      if (error === 404) {
        this.router.navigate(['404']);
      } else {
        this.router.navigate(['error']);
      }
      return observableOf(null);
    }));
  }
}
